module.exports = __webpack_public_path__ + "static/media/NFT_turtle.fd943046.png";